import { ControlButton, Controls } from "reactflow";
export function CustomControls() {
  return (
    <div>
      <Controls />
    </div>
  );
}
